"use client";
import { T as t } from "./useAnimationsFinished-DDpUuXkZ.mjs";
let r = function(n) {
  return n.open = "data-open", n.closed = "data-closed", n[n.startingStyle = t.startingStyle] = "startingStyle", n[n.endingStyle = t.endingStyle] = "endingStyle", n.anchorHidden = "data-anchor-hidden", n;
}({}), e = /* @__PURE__ */ function(n) {
  return n.popupOpen = "data-popup-open", n.pressed = "data-pressed", n;
}({});
const p = {
  [e.popupOpen]: ""
}, s = {
  [e.popupOpen]: "",
  [e.pressed]: ""
}, d = {
  [r.open]: ""
}, a = {
  [r.closed]: ""
}, O = {
  [r.anchorHidden]: ""
}, c = {
  open(n) {
    return n ? p : null;
  }
}, i = {
  open(n) {
    return n ? s : null;
  }
}, o = {
  open(n) {
    return n ? d : a;
  },
  anchorHidden(n) {
    return n ? O : null;
  }
};
export {
  r as C,
  i as a,
  o as p,
  c as t
};
